import axios from 'axios'

const api = axios.create({
    baseURL: window.location.hostname === 'localhost'
        ? 'http://localhost:8081' // For local environment
        : 'http://128.95.204.84:8081', // For remote
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});


export default api;